import qs from 'qs';

/**
 * Shared utilities for parsing filter state from URL query params.
 * Used by both the homepage feed (useAdditionalFilters) and profile feed (useProfileAdditionalFilters).
 */

export const normalizeToArray = (value: string | string[] | undefined): string[] => {
	if (!value) return [];
	return Array.isArray(value) ? value : [value];
};

interface FilterQueryParams {
	hashtags?: string | string[];
	types?: string | string[];
	[key: string]: unknown;
}

export const parseFilterParams = (search: string): { types: string[]; hashtags: string[] } => {
	const parsed = qs.parse(search, { ignoreQueryPrefix: true }) as FilterQueryParams;
	return {
		hashtags: normalizeToArray(parsed.hashtags),
		types: normalizeToArray(parsed.types),
	};
};
